import { API } from "./../../../api/config";

export const getPaymentTermsAPI = (params) => {
    return API.get("/pmbpartner/payment-terms", { params })
              .then((res) => res);
};

export const createTermAPI = (payload) => {
    return API.post("/pmbpartner/payment-terms", payload)
              .then((res) => res);
};

export const getTermPartnersAPI = (params) => {
    return API.get("/pmbpartner/payment-terms/get-partners", { params })
              .then((res) => res);
};

export const getTermsByIdAPI = (termSk) => {
    return API.get(`/pmbpartner/payment-terms/${termSk}`)
              .then((res) => res);
};

export const updateTermAPI = (payload) => {
    return API.patch(`/pmbpartner/payment-terms/${payload.termSK}`, payload.body)
              .then((res) => res);
};